<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 38.97 44.46" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="m31.15 4.82-.49-4.32h-5.29l-.5 4.32z"/><path d="m24.35 9.44-3.92 34.56h15.17l-3.92-34.56z"/><path d="m.5 4.83h37.3v4.61h-37.3z"/><path d="m4.53 9.44h6.11v4h-6.11z"/><path d="m7.59 19.46v-6"/><path d="m7.64 19.35a4.5 4.5 0 1 0 4.5 4.5"/><path d="m28.2 9.44-4.19 3 8.81 7-10.42 7.16 12.06 7.4-13.58 6"/><path d="m25.37.5 3.94 4.33"/><path d="m.5 44h38"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
